import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClockPresentation = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.419 11.362A8.36 8.36 0 0 1 12.78 3a8.362 8.362 0 0 1 0 16.725"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.425 13.752-2.95-1.763V8.18"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.374 19.97a.4.4 0 0 0-.27-.102H3.823a1.22 1.22 0 0 1-1.218-1.218v-3.248c0-.673.545-1.218 1.218-1.218h4.871c.673 0 1.218.545 1.218 1.218v3.248c0 .673-.545 1.218-1.218 1.218h-.406a.203.203 0 0 0-.203.203v.968a.203.203 0 0 1-.338.152z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClockPresentation);
export default ForwardRef;
